import {
  ALL_DATA_VALUE,
  JOURNEYS_VALUE,
  OTT_VALUE,
  QUICK_LINKS_VALUE,
  UNIVERSAL_ADS_VALUE,
  UNIVERSAL_EMAIL_VALUE,
} from '../summary';

export const ADS_TABLE = 'ads-table';
export const ADS_TOTALS = 'ads-table-totals';
export const ADS_TRENDS = 'ads-time-series';

export const ROI_ANALYTICS_TABLE = 'roi-analytics-table';
export const ROI_ANALYTICS_TOTALS = 'roi-analytics-totals';

export const SEO_TABLE = 'seo-report-table';
export const SEO_TOTALS = 'seo-report-table-totals';
export const SEO_TRENDS = 'seo-trends-time-series';

export const QR_CODE_LINK_TABLE = 'qr-code-link-report-table';
export const QR_CODE_LINK_TOTALS = 'qr-code-link-report-table-totals';
export const QR_CODE_LINK_TRENDS = 'qr-code-link-trends-time-series';

export const TRUEVIEW_TABLE = 'trueview-report-table';
export const TRUEVIEW_TOTALS = 'trueview-report-table-totals';
export const TRUEVIEW_TRENDS = 'trueview-trends';

export const SKAN_UNIFIED_TABLE = 'skan-unified-report-table' as const;
export const SKAN_UNIFIED_TOTALS = 'skan-unified-report-table-totals' as const;
export const SKAN_UNIFIED_TRENDS = 'skan-unified-trends' as const;

export const SOURCES_TABLE = 'source-table';
export const SOURCES_TOTALS = 'source-table-totals';

export const OTT_TABLE = 'ott-report-table';
export const OTT_TOTALS = 'ott-report-table-totals';
export const OTT_TRENDS = 'ott-trends-time-series';
export const OTT_WIDGETS = 'ott-widgets';

export const JOURNEYS_TABLE = 'journeys-performance-table';
export const JOURNEYS_TOTALS = 'journeys-performance-table-totals';
export const JOURNEYS_TRENDS = 'journeys-time-series';
export const JOURNEYS_HISTORY_TABLE = 'journeys-history-report-table';

export const EMAILS_TABLE = 'email-performance-table';
export const EMAILS_TOTALS = 'email-performance-table-totals';
export const EMAILS_TRENDS = 'email-time-series';

export const SUMMARY_TABLE = 'summary-table';
export const SUMMARY_TABLE_ALL = `${SUMMARY_TABLE}__${ALL_DATA_VALUE}` as const;
export const SUMMARY_TABLE_JOURNEYS = `${SUMMARY_TABLE}__${JOURNEYS_VALUE}` as const;
export const SUMMARY_TABLE_QUICK_LINKS = `${SUMMARY_TABLE}__${QUICK_LINKS_VALUE}` as const;
export const SUMMARY_TABLE_UNIVERSAL_ADS = `${SUMMARY_TABLE}__${UNIVERSAL_ADS_VALUE}` as const;
export const SUMMARY_TABLE_UNIVERSAL_EMAIL = `${SUMMARY_TABLE}__${UNIVERSAL_EMAIL_VALUE}` as const;
export const SUMMARY_TABLE_OTT = `${SUMMARY_TABLE}__${OTT_VALUE}` as const;

export const SUMMARY_TOTALS = 'summary-table-totals';
export const SUMMARY_TRENDS = 'summary-time-series';
export const SUMMARY_TRENDS_ALL = `${SUMMARY_TRENDS}__${ALL_DATA_VALUE}` as const;
export const SUMMARY_TRENDS_JOURNEYS = `${SUMMARY_TRENDS}__${JOURNEYS_VALUE}` as const;
export const SUMMARY_TRENDS_QUICK_LINKS = `${SUMMARY_TRENDS}__${QUICK_LINKS_VALUE}` as const;
export const SUMMARY_TRENDS_UNIVERSAL_ADS = `${SUMMARY_TRENDS}__${UNIVERSAL_ADS_VALUE}` as const;
export const SUMMARY_TRENDS_UNIVERSAL_EMAIL = `${SUMMARY_TRENDS}__${UNIVERSAL_EMAIL_VALUE}` as const;
export const SUMMARY_TRENDS_OTT = `${SUMMARY_TRENDS}__${OTT_VALUE}` as const;
export const SUMMARY_TILE = 'summary-tile';
export const SUMMARY_TILE_ALL = `${SUMMARY_TILE}__${ALL_DATA_VALUE}` as const;
export const SUMMARY_TILE_JOURNEYS = `${SUMMARY_TILE}__${JOURNEYS_VALUE}` as const;
export const SUMMARY_TILE_QUICK_LINKS = `${SUMMARY_TILE}__${QUICK_LINKS_VALUE}` as const;
export const SUMMARY_TILE_UNIVERSAL_ADS = `${SUMMARY_TILE}__${UNIVERSAL_ADS_VALUE}` as const;
export const SUMMARY_TILE_UNIVERSAL_EMAIL = `${SUMMARY_TILE}__${UNIVERSAL_EMAIL_VALUE}` as const;
export const SUMMARY_TILE_OTT = `${SUMMARY_TILE}__${OTT_VALUE}` as const;
export const QUICK_LINKS_TABLE = 'quick-links-table';
export const QUICK_LINKS_TOTALS = 'quick-links-table-totals';
export const QUICK_LINKS_TRENDS = 'quick-links-time-series';

export const DISCO_DASHBOARD_TABLE = 'disco-dashboard';
export const DISCO_DASHBOARD_TOTALS = 'disco-dashboard-totals';

export const COHORT_MODAL = 'cohort-modal';

export const TABLE_TO_TOTALS_MAPPING = {
  [ADS_TABLE]: ADS_TOTALS,
  [SEO_TABLE]: SEO_TABLE,
  [SOURCES_TABLE]: SOURCES_TOTALS,
  [JOURNEYS_TABLE]: JOURNEYS_TOTALS,
  [EMAILS_TABLE]: EMAILS_TOTALS,
  [SUMMARY_TABLE]: SUMMARY_TOTALS,
  [DISCO_DASHBOARD_TABLE]: DISCO_DASHBOARD_TABLE,
  [ROI_ANALYTICS_TABLE]: ROI_ANALYTICS_TOTALS,
};
